export const COLORS = {
  primary: '#3C82C2',
  sidemenu_text: '#9F9F9F',
  white: '#FFFFFF',
};
